import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SurveyComponent } from './ui/survey/survey.component';

const routes: Routes = [
  {
    path: '',
    component: SurveyComponent
  },
  {
    path: ':surveyid',
    component: SurveyComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
